import { NavItems } from "./NavItems";
import { useState } from "react";
import "./navBar.scss";
import { FaBars } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { AuthContext } from "../../context/AuthContext";
import { useEffect } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import SlideInModal from "../slideInModal/SlideInModal";
import Cart from "../Cart/Cart";

const Navbar = () => {
  const { buyer, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const products = useSelector((state) => state.cart.products);
  const [prevProductCount, setPrevProductCount] = useState(products.length);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (products.length > prevProductCount) {
  //     toast.success("New product added to the cart!", {
  //       position: toast.POSITION.BOTTOM_LEFT,
  //     });
  //   }
  //   setPrevProductCount(products.length);
  // }, [products]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const openPopup = () => {
    setShow(true);
  };
  const cloesPopup = () => {
    setShow(false);
  };


  const openCart = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="__fw">
      <div className="__mw">
        <nav className="NavbarItems">
          <div className="Logo_wrp">
            <Link to="/">
              <img
                className="logo_img"
                src={require("../../img/logo.png")}
                alt=""
              />
            </Link>
          </div>
          <div className="Hamburger-Cross-Icons">
            {open ? (
              <IoClose color="black" size={27} onClick={handleClickClose} />
            ) : (
              <FaBars color="black" size={27} onClick={handleClickOpen} />
            )}
          </div>
          <ul className={open ? "MenuItems active" : "MenuItems"}>
            <Link to={"/"} onClick={handleClickClose}>
              <li className="nv">Home</li>
            </Link>
            <Link to={"/Shop"} onClick={handleClickClose}>
              <li className="nv">Shop</li>
            </Link>
            {/* <Link to={"/contact"} onClick={handleClickClose}>
              <li className="nv">Contact</li>
            </Link> */}

            {buyer ? (
              <>
                <Link to={"/profile"}>
                  <div className="pro_nam_wrp">
                    <span>{buyer.fullName?.substring(0, 2).toUpperCase()}</span>
                  </div>
                </Link>
              </>
            ) : (
              <>
                <Link to={"/register"} onClick={handleClickClose}>
                  <li className="nv">Register</li>
                </Link>
                <Link to={"/loing"} onClick={handleClickClose}>
                  <li className="nv">Login</li>
                </Link>
              </>
            )}

            <>
              <div className="item" onClick={openCart}>
                <div className="icons">
                  <div className="shoppingCart">
                    <div className="cartIcon">
                      <FaShoppingCart />
                      <span>{products.length}</span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </ul>
        </nav>
        <>
          <SlideInModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          >
            <Cart closeCart={() => setIsModalOpen(false)} />
          </SlideInModal>
        </>
      </div>
    </div>
  );
};
export default Navbar;
